import React, { forwardRef } from 'react';
import type { IconButtonProps } from '@mui/material';
import { IconButton as IconButtonMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

import { CUSTOM_ATTRIBUTE_READ_ONLY } from './IconButton.api';

type Props = {
  readOnly?: boolean;
};

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps & Props>((props, ref) => (
  <IconButtonMUI
    {...omitUndefinedProps({ ...props, [CUSTOM_ATTRIBUTE_READ_ONLY]: props.readOnly ? '' : undefined })}
    ref={ref}
  />
));

IconButton.displayName = 'IconButton';

export default IconButton;
